// Shared amount/unit formatting for the MenuTest charts (products + sections).

import { formatAmounts } from '@aytm/app/stats/lib/util/helpers'

import { VIEW_MODES } from '@aytm/app/stats/page/question-views/mn/lib/viewOptions'

export const formatAmount = (raw, viewMode) => {
  if ([VIEW_MODES.P_AMOUNT, VIEW_MODES.P_VOLUME].includes(viewMode)) {
    // Coffee calls `.toFixed` directly and would crash on a string; Number() keeps parity for numbers.
    return Number(raw).toFixed(2)
  }
  return formatAmounts({ amount: raw }, 'amount', 1)
}

// Plural check runs on the already-formatted string — formatAmounts never emits
// thousands separators, so Number() matches coffee's parseFloat and "1" stays singular.
export const calcUnitLabel = ({ viewMode, amount, percentCapableViews, secondsModes }) => {
  if (secondsModes.includes(viewMode)) {
    return `second${Number(amount) !== 1 ? 's' : ''}`
  }
  if (percentCapableViews.includes(viewMode)) {
    return `respondent${Number(amount) !== 1 ? 's' : ''}`
  }
  return ' '
}
